import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';
import {StoreReleaseNotes} from '../typescript/storeTypes';
import {InitialState} from './initialState';

export default function (state: StoreReleaseNotes = InitialState.releaseNotes, action: Action): StoreReleaseNotes {
    switch (action.type) {
        case ActionTypes.GET_RELEASE_NOTES_SUCCEEDED: {
            return Object.assign({}, state, action.payload);
        }
        default: {
            return state;
        }
    }
}
